export default __webpack_public_path__ + "static/media/amazonBtn.054b82b6.png";